<template>
  <div class="mit-equipment-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Events</v-card-title>
            <v-card-subtitle class="caption">CSAIL Events Information</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
              <h3 class="pt-5">
                <a href="https://calendar.csail.mit.edu/mrbs" target="_blank">
                Conference Rooms
                </a>
              </h3>
              <p>CSAIL conference room booking</p>

              <h3 class="pt-5">
                <a href="https://calendar.csail.mit.edu/" target="_blank">
                Event Publishing
                </a>
              </h3>
              <p>CSAIL event publishing</p>

            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

  export default {
    name: 'MitEventsPage',
    components: {
    },
    data: function() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // exampleFunction: function(model) {
      //   console.log(model);
      // }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
